import {
  useAccount, useWorkspaceMetricPreferences, useWorkspacePreferences,
} from "../../../../hooks/QueryHooks";
import useAccountPageParams from "../../../../hooks/useAccountPageParams";
import useWorkspaceStore from "../../../../store/workspace/workspaceStore";
import TrendsContainer from "./components/TrendsContainer";

const AccountOverview = () => {
  const currentWorkspace = useWorkspaceStore((state) => state.workspace);

  const params = useAccountPageParams();
  const account: any = useAccount({
    accountId: params.accountId || "",
    workspaceId: currentWorkspace?.id,
    enabled: params.accountId !== "" && currentWorkspace !== "",
  });

  const prefs: any = useWorkspacePreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });
  const metrics: any = useWorkspaceMetricPreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });

  return (
    <div className="space-y-6">
      {account?.data?.external_id && prefs.isSuccess && metrics.isSuccess && (
        <TrendsContainer
          prefs={prefs}
          metrics={metrics?.data?.filter((m: any) => m.linked_entity === "accounts")}
          account={account?.data}
          containerClassName="border border-gray-200 rounded-lg"
          currentWorkspace={currentWorkspace}
        />
      )}
    </div>
  );
};

export default AccountOverview;
